<template lang="pug">
  v-layout(justify-center)
    v-alert(
      outline,
      :value="show",
      color="error",
      icon="priority_high") {{ text }}
</template>

<script>
export default {
  name: 'Alert',
  props: {
    show: {
      type: Boolean,
      default: false,
      require: true
    },
    text: {
      type: String,
      default: '',
      require: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/Alert/Alert.vue